var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronFillDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 5.66663C12.2696 5.66675 12.5122 5.82901 12.6155 6.07776C12.7187 6.32688 12.6616 6.61366 12.471 6.80432L8.47098 10.8043C8.21063 11.0647 7.78894 11.0647 7.52859 10.8043L3.52859 6.80432C3.33807 6.61366 3.28091 6.3268 3.38406 6.07776C3.48733 5.82884 3.73076 5.66663 4.00027 5.66663H12.0003Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronFillDown);
export default __webpack_public_path__ + "static/media/chevron-fill-down.8e508aefc9930acfbdb33c85f0fa2819.svg";
export { ForwardRef as ReactComponent };